// extracted by css-extract-rspack-plugin
export default {"page":"Fu5KNsUCDzQTIJIx","content":"r1JXxW7BYfgl4dZW"};